/**
 * A contract's terms live in a schema-labelled envelope:
 *   contractData: { schema, schemaVersion, body }
 * For the GRLC placement editor the body is the placement object. Supporting
 * another schema version means changing this file only.
 *
 * Values inside body (e.g. dates as { $date: "..." }) are passed through
 * untouched, so anything the editor doesn't change goes back as it came.
 */

export const MRCAI_GRLC_V1 = { schema: "mrcai.grlc", schemaVersion: "1" };

const isGrlcV1 = (contractData) =>
  contractData?.schema === MRCAI_GRLC_V1.schema &&
  String(contractData?.schemaVersion) === MRCAI_GRLC_V1.schemaVersion;

/**
 * Whether the contract's terms can be edited as a GRLC v1 placement:
 * true when it has none yet (contractData null) or they are mrcai.grlc v1.
 */
export const isPlacementSupported = (contract) =>
  !contract?.contractData || isGrlcV1(contract.contractData);

/** The contract's GRLC placement, or null when it has none or another schema. */
export const readPlacement = (contract) =>
  isGrlcV1(contract?.contractData) ? contract.contractData.body ?? null : null;

/** A copy of the contract with the placement stored as mrcai.grlc v1 terms. */
export const withPlacement = (contract, placement) => ({
  ...contract,
  contractData: { ...MRCAI_GRLC_V1, body: placement },
});
